import { create } from 'zustand';

export interface ContextAwareness {
  card: string;
  sourceUrl: string;
}

interface ContextAwarenessState {
  contextAwareness: ContextAwareness;
  setContextAwareness: (contextAwareness: ContextAwareness) => void;
  reset: () => void;
}

const initialContextAwareness: ContextAwareness = {
  card: '',
  sourceUrl: '',
};

const useContextAwarenessStore = create<ContextAwarenessState>((set) => ({
  contextAwareness: initialContextAwareness,
  setContextAwareness: (contextAwareness) => set({ contextAwareness }),
  reset: () => set({ contextAwareness: initialContextAwareness }),
}));

export default useContextAwarenessStore;
